import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import websiteRoute from './View/Website/Route'
import userRoute from './View/User/Route'
import adminRoute from './View/Admin/Route'
import StartAsGuestButton from './View/Website/Components/StartAsGuestButton'
import { startIdleLogout } from './utils/auth';
import './View/css/theme.css'
import './View/css/style.css'
import './View/css/theme-apply.css'
// import './View/css/mobile_menu.css'
// import './View/css/responsive.css'
// import './View/css/custom_spacing.css'

function IdleLogout() {
  useEffect(() => startIdleLogout(), []);
  return null;
}

function AppShell() {
  return (
    <>
      <IdleLogout />
      <Outlet />
      <StartAsGuestButton />
    </>
  );
}
const App = () => {
  return (<>
        <ToastContainer />
        <RouterProvider router={createBrowserRouter([{ element: <AppShell />, children: [
          ...websiteRoute,
          ...userRoute,
          ...adminRoute,
        ] }])} />
  </>)
}

export default App;
